// extracted by mini-css-extract-plugin
export var restrictedWidthButton = "_sc-0";